import { GlobalStatus, StatusEnum } from "@gtpl/shared-models/common-models";
import { BomDetails } from "../bom-calculation.entity";
import { BomPackingItemsDto } from "../dto/packing-materials.dto";
import { PoBomItem } from "../dto/po-bom-item.dto";
import { SaleOrder } from "../sale-order.entitiy";

export class PackingMaterialAdapter {

  convertDtoToEntity(bomData: BomPackingItemsDto): BomDetails {
    const bomEntity = new BomDetails();
    bomEntity.itemCategoryId = bomData.itemCategoryDetails.itemCategoryId;
    bomEntity.itemId = bomData.itemDetails.itemId;
    bomEntity.size = bomData.size.sizeId;
    bomEntity.quantity = bomData.quantity;

    bomEntity.saleOrderInfo = new SaleOrder();
    bomEntity.saleOrderInfo.saleOrderId = bomData.saleOrderId;
    bomEntity.createdUser = bomData.createdUser;
    if (!bomData.packingMaterialId) {
      bomEntity.createdUser = bomData.createdUser;
    } else {
      bomEntity.updatedUser = bomData.updatedUser;
      bomEntity.packingMaterialId = bomData.packingMaterialId;
    }
    return bomEntity;
  }

  convertPoBomDtoToEntity(bomData: PoBomItem): BomDetails {
    const bomEntity = new BomDetails();
    bomEntity.itemCategoryId = bomData.itemCategoryId;
    bomEntity.itemSubCategoryId = bomData.itemSubCategoryId;
    bomEntity.itemId = bomData.itemId;
    bomEntity.size = bomData.sizeId;
    bomEntity.quantity = bomData.quantity;
    bomEntity.requiredQuantity = bomData.quantity;
    bomEntity.poQty = bomData.quantity;
    bomEntity.packingCategory = 'Added In PO';
    bomEntity.saleOrderInfo = new SaleOrder();
    bomEntity.saleOrderInfo.saleOrderId = bomData.saleOrderId;
    bomEntity.createdUser = bomData.createdUser;
    bomEntity.isRequired = GlobalStatus.YES;
    bomEntity.status = StatusEnum.PO;
    return bomEntity;
  }

  // convertDtoToEntity(bomData: BomPackingItemsDto[]): SaleOrder {
  //     const soOrder = new SaleOrder();
  //     soOrder.saleOrderId = bomData[0].saleOrderId;
  //     console.log(bomData[0].saleOrderId);
  //     const bomPackingItemsInfo : BomDetails[] =[]
  //     for(const packingBom of bomData){
  //         const bomEntity = new BomDetails();
  //         bomEntity.itemCategoryId = packingBom.itemCategoryDetails.itemCategoryId;
  //         bomEntity.itemId = packingBom.itemDetails.itemId;
  //         bomEntity.size = packingBom.size.sizeId;
  //         bomEntity.quantity = packingBom.quantity;
  //         bomEntity.createdUser = packingBom.createdUser;
  //         if(!packingBom.packingMaterialId){
  //          bomEntity.createdUser = packingBom.createdUser;
  //         }else{
  //           bomEntity.updatedUser = packingBom.updatedUser;
  //           bomEntity.packingMaterialId = packingBom.packingMaterialId;
  //         }
  //         bomPackingItemsInfo.push(bomEntity);
  //     }
  //     soOrder.BomDetailsInfo = bomPackingItemsInfo
  //     return soOrder;
  //  }

}